import { useLanguage } from '@/contexts/LanguageContext';

export default function ContactCTA() {
  const { t } = useLanguage();

  const scrollToForm = () => {
    const el = document.getElementById('contact-form');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="section-padding bg-[#F5F8FB]">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div
          className="relative overflow-hidden rounded-2xl px-8 py-14 md:px-16 md:py-20 text-center"
          style={{ background: 'linear-gradient(135deg, #0273C2 0%, #00B894 100%)' }}
        >
          <div
            className="absolute -top-16 -right-16 w-64 h-64 rounded-full opacity-15 pointer-events-none"
            style={{ background: 'radial-gradient(circle, #fff 0%, transparent 70%)' }}
            aria-hidden="true"
          />
          <div
            className="absolute -bottom-12 -left-12 w-48 h-48 rounded-full opacity-10 pointer-events-none"
            style={{ background: 'radial-gradient(circle, #fff 0%, transparent 70%)' }}
            aria-hidden="true"
          />

          <div className="relative">
            <p className="text-white/80 text-[1rem] font-semibold uppercase tracking-widest mb-4">
              {t('開始您的旅程', 'Start Your Journey', 'あなたの旅を始めましょう')}
            </p>
            <h2
              className="font-bold text-white mb-6 max-w-2xl mx-auto"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.25rem)', lineHeight: '1.4' }}
            >
              {t(
                '從一次材料評估開始，建立可量產的低碳產品路徑',
                'Start with a Material Assessment — Build a Scalable Low-Carbon Product Pathway',
                '材料評価から始めて、量産可能な低炭素製品パスウェイを構築しましょう'
              )}
            </h2>
            <p className="text-white/80 text-[1.0625rem] max-w-xl mx-auto mb-10 leading-relaxed">
              {t(
                '聚量提供從材料評估、試產驗證到量產導入的完整支援，協助您打造具競爭力的循環材料解決方案。',
                'PolyQ provides comprehensive support from material assessment and pilot production to full-scale manufacturing, helping you build competitive circular material solutions.',
                '聚量は材料評価・試験生産・量産導入まで包括的なサポートを提供し、競争力のあるサーキュラー材料ソリューションの構築をお手伝いします。'
              )}
            </p>
            <button
              type="button"
              onClick={scrollToForm}
              className="inline-flex items-center gap-2 px-10 py-4 rounded-full bg-white text-brand-green text-[1.0625rem] font-bold hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              {t('送出諮詢需求', 'Submit Inquiry', 'お問い合わせを送信')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
